"use client"

import type { SVGProps } from "react"

export function MeridialLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 133 149"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M100 0.5L67 143L35.0299 61.0854L100 0.5Z" fill="#D6BBFB" />
      <path d="M35.5 8.5L67 143.5L25 74.5L35.5 8.5Z" fill="#E9D7FE" />
      <g filter="url(#filter0_i_332_1208)">
        <path
          d="M51.5 24L67.5 143L24.8239 79.9785C24.6234 79.6824 24.5964 79.3019 24.7528 78.9803L51.5 24Z"
          fill="#7F56D9"
        />
      </g>
      <g filter="url(#filter1_i_332_1208)">
        <path d="M72.4818 43L67.5 144L25 84.5L72.4818 43Z" fill="#9E77ED" />
      </g>
      <defs>
        <filter
          id="filter0_i_332_1208"
          x="24.652"
          y="24"
          width="42.848"
          height="125"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_332_1208"
          />
        </filter>
        <filter
          id="filter1_i_332_1208"
          x="25"
          y="43"
          width="47.4818"
          height="107"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_332_1208"
          />
        </filter>
      </defs>
    </svg>
  )
}
